<template>
  <div class="train_effect_report w_d fff">
    <h2 class="title_com">培训效果报告</h2>
    <section class="pd2430">
      <!-- 基本数据 -->
      <h2 class="fs20 mb20">基本数据</h2>
      <el-row class="mb20 border bdr4" style="font-size: 16px; padding: 20px">
        <el-col :span="4">
          <section class="col-height">
            学员数：<span class="recommend-label">{{
              baseData.member_num
            }}</span>
          </section>
        </el-col>
        <el-col :span="4">
          <section class="col-height">
            合格人数：<span class="recommend-label">{{
              baseData.qualified_num
            }}</span>
          </section>
        </el-col>
        <el-col :span="4">
          <section class="col-height">
            合格率：<span class="recommend-label">{{
              baseData.qualified_rate
            }}</span>
          </section>
        </el-col>
        <el-col :span="4">
          <section class="col-height">
            优秀人数：<span class="recommend-label">{{
              baseData.excellent_num
            }}</span>
          </section>
        </el-col>
        <el-col :span="4">
          <section class="col-height">
            优秀率：<span class="recommend-label">{{
              baseData.excellent_rate
            }}</span>
          </section>
        </el-col>
      </el-row>
      <!-- 学习情况分析统计 -->
      <div class="satisfaction my_flex">
        <h2 class="fs20">学习情况分析统计</h2>
        <div class="two_btn">
          <el-button type="primary" size="mini" @click="customExpertAdd()"
            >自定义表头</el-button
          >
          <el-button type="primary" size="mini" @click="handleAvgExport"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 学习情况分析统计表格 -->
      <el-table
        :data="postList"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          fontWeight: 500,
          color: '#333',
        }"
        class="mgtb20"
      >
        <div v-for="(aitem, aindex) in headerList" :key="aindex">
          <el-table-column
            :label="aitem.c_name"
            align="center"
            :prop="aitem.name"
            show-overflow-tooltip
          />
        </div>
        <el-table-column
          label="操作"
          align="center"
          width="1px"
        ></el-table-column>
      </el-table>
      <!-- 学习情况分析统计分页 -->
      <Pagination
        :currentPage="currentPage"
        :pageSize="pageSize"
        :total="total"
        :selectSize="[10, 20, 30, 40]"
        @changePage="changePage"
        @changeSize="changeSize"
        v-if="total !== 0"
      ></Pagination>
      <!-- 成绩得分统计 -->
      <div class="satisfaction my_flex mt18">
        <h2 class="fs20">成绩得分统计</h2>
        <div class="two_btn">
          <el-button type="primary" size="mini" @click="scoreStatisticsCustom"
            >自定义表头</el-button
          >
          <el-button type="primary" size="mini" @click="scoreStatisticsExport"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 成绩得分统计表格 -->
      <el-table
        :data="blanksList"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          fontWeight: 500,
          color: '#333',
        }"
        class="mgtb20"
      >
        <div v-for="(aitem, aindex) in headerBlanksList" :key="aindex">
          <el-table-column
            :label="aitem.c_name"
            align="center"
            :prop="aitem.name"
            show-overflow-tooltip
          />
    </div>
        <el-table-column
          label="操作"
          align="center"
          width="1px"
        ></el-table-column>
      </el-table>
      <!-- 成绩得分统计分页 -->
      <Pagination
        :currentPage="currentPage2"
        :pageSize="pageSize2"
        :total="total2"
        :selectSize="[10, 20, 30, 40]"
        @changePage="changePage2"
        @changeSize="changeSize2"
        v-if="total2 !== 0"
      ></Pagination>
    </section>
    <!-- 自定义表头dialog -->
    <CustomHeaderDialog ref="childCustomHeader"></CustomHeaderDialog>
  </div>
</template>

<script>
import {
  TrainEffectBaseData,
  TrainEffectStudyStatisticsList,
  TrainEffectStudyStatisticsListExport,
  TrainEffectStudyScoreList,
  TrainEffectStudyScoreListExport
} from "@/api/projectAdministrator";
export default {
  data() {
    return {
      baseData: {}, // 基本数据
      postList: [], // 学习情况分析统计列表
      headerList: [], // 学习情况分析统计表头
      blanksList: [], // 成绩得分统计列表
      headerBlanksList: [], // 成绩得分统计表头
      currentPage: 1, //当前页数
      pageSize: 10, // 当前页条数
      total: 11, // 总数
      currentPage2: 1, //当前页数
      pageSize2: 10, // 当前页条数
      total2: 11, // 总数
      class_id: "",
    };
  },
  methods: {
    ScoreListFn() {
      TrainEffectStudyScoreList({
        class_id: this.class_id,
        page: this.currentPage2,
        limit: this.pageSize2,
      }).then((res) => {
        this.headerBlanksList = res.data.header;
        this.blanksList = res.data.list;

        this.total2 = res.data.total;
      });
    },
    // 成绩得分统计自定义导出
    scoreStatisticsExport() {
      if (this.blanksList.length === 0) {
        this.messageTips("暂无导出数据", "warning");
        return false;
      }
      TrainEffectStudyScoreListExport({ class_id: this.class_id }).then((res) => {
        saveAs(res, "成绩得分统计.xls");
      });
    },
    // 成绩得分统计自定义表头
    scoreStatisticsCustom() {
      this.$refs.childCustomHeader.operationDialog(
        this.class_id,
        10,
        this.ScoreListFn,
        ""
      );
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.studyStatisticsListFn();
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.studyStatisticsListFn();
    },
    // 当前页数条数改变
    changeSize2(size) {
      this.pageSize2 = size;
      this.ScoreListFn();
    },
    // 当前页数改变
    changePage2(page) {
      this.currentPage2 = page;
      this.ScoreListFn();
    },
    studyStatisticsListFn() {
      TrainEffectStudyStatisticsList({
        class_id: this.class_id,
        page: this.currentPage,
        limit: this.pageSize,
      }).then((res) => {
        this.postList = res.data.detail_data;
        this.headerList = res.data.header;

        this.total = res.data.total;
      });
    },
    // 学习情况分析统计导出
    handleAvgExport() {
      if (this.postList.length === 0) {
        this.messageTips("暂无导出数据", "warning");
        return false;
      }
      TrainEffectStudyStatisticsListExport({ class_id: this.class_id }).then(
        (res) => {
          saveAs(res, "学习情况分析统计.xls");
        }
      );
    },
    // 学习情况分析统计自定义表头
    customExpertAdd() {
      this.$refs.childCustomHeader.operationDialog(
        "",
        2,
        this.studyStatisticsListFn,
        ""
      );
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      // 基本数据
      TrainEffectBaseData({ class_id: this.class_id }).then((res) => {
        this.baseData = res.data;
      });
      // 培训效果报告学习情况分析统计列表
      this.studyStatisticsListFn();
      // 培训效果报告成绩得分统计列表
      this.ScoreListFn();
    },
  },
  created() {
    this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.train_effect_report {
}
</style>